import React, { useEffect, useState } from 'react';
import styles from './categories.module.scss';
import { KoButton, KoForm,  KoLoader,  KoModal, KoNano, KoPagination, KoTable, KoTitle, KoToast, KoTooltips } from 'packages';
import { CategoryColum } from './constant';
import CurdCategory from './curd';
import { adminConsoleAPI } from '../../admin.service';
import KoIcon from '@kwapio/icons';

export default function Categories() {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [form] = KoForm.useForm();
  const [currentRecord, setCurrentRecord] = useState();
  const [isLoading, setLoading] = useState(false);
  const [categoryList,setCategoryList]=useState([]);

  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1
  });

  const [totalCount, setTotalCount] = useState(0);
  console.log(setTotalCount);

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (text, row) => {
      return <div className={`tableBtn columnsRight`} onClick={() => { form.resetFields(); setCurrentRecord(row); }}>
        {row?.status === 0 &&  <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />}  />
        </KoTooltips>}
        {row?.status === 0 &&  <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>}
      </div>;
    }
  }];

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page
    };
    const p = Object.assign(pagination, query);
    setPagination({ ...p });
  };

  useEffect(()=>{
    getCategoryList();
  },[]);

  const getCategoryList = async() => {
    try {
      let res={};
      res = await adminConsoleAPI.getCategoryList().then(
        (data)=>{
          setLoading(false);
          setCategoryList(data.category);
          setTotalCount(res?.totalCount);
        }
      );

    } catch (error) {
      console.log("Error fetching Category:", error);
    }
  };

  const handleFinish = (values) => {
    if (!currentRecord?.categoryId) {
      values["categoryId"] = KoNano("CAT");
    }
    adminConsoleAPI.createCategory(values, currentRecord?.categoryId).then(
      (data) => {
        setLoading(false);
        KoToast.success('Added successfully');
      },
      (err) => {
        setLoading(false);
        KoToast.error('Something went wrong');
        console.log("Error:", err);
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}
      <div className={`${styles.content} tableCard`}>
        <div className={styles.header}>
          <KoTitle text='Category' level={4} />
          <KoButton color="primary" variant="solid" label='Add Category' onClick={() => setIsModalOpen(true)} />
        </div>
        <KoTable extraColumnsRight={columnsRight} data={{ columns: CategoryColum, rows: categoryList }}  />
        <KoPagination
          current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.size}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false}
        />
      </div>

      <KoModal title='Add Category'
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        afterClose={() => { setCurrentRecord(); }}
        width={'60vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setIsModalOpen(false)} />,
          <KoButton key='reset' type='primary' label='Create' onClick={() => {form.submit();setIsModalOpen(false);console.log('create category');}} />
        ]}
      >
        <CurdCategory form={form}  handleFinish={handleFinish} />
      </KoModal>
    </div>
  );
}
